import {DialogPrimitive as Dialog} from "ch3-ui-lib";
import {PhoneHQButton} from "ch3-ui-lib";
import {X} from "lucide-react";
import {useEffect, useState} from "react";
import {PhoneNumberInput} from "../../components/Dialer/components/PhoneInput";
import {lucide} from "./queueUi";

interface ExternalNumberDialogProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    initial?: string;
    onSave: (phoneNumber: string) => void;
}

/** "Send to external number…": a number outside PhoneHQ for one key. */
export const ExternalNumberDialog = ({open, onOpenChange, initial, onSave}: ExternalNumberDialogProps) => {
    const [phoneNumber, setPhoneNumber] = useState(initial ?? '');

    useEffect(() => {
        if (open) setPhoneNumber(initial ?? '');
    }, [open, initial]);

    const valid = phoneNumber.replace(/\D/g, '').length >= 3;

    return (
        <Dialog.Root open={open} onOpenChange={onOpenChange}>
            <Dialog.Portal>
                <Dialog.Overlay className="fixed inset-0 z-[60] bg-scrim"/>
                <Dialog.Content
                    aria-describedby="external-number-desc"
                    className="fixed left-1/2 top-1/2 z-[60] flex w-[min(440px,calc(100%-2rem))] -translate-x-1/2 -translate-y-1/2 flex-col overflow-hidden rounded-card bg-surface text-ink shadow-overlay outline-none"
                >
                    <div className="flex h-14 shrink-0 items-center border-0 border-b border-solid border-line px-5">
                        <Dialog.Title className="m-0 flex-1 text-body-strong">Send to external number</Dialog.Title>
                        <Dialog.Close aria-label="Close" className="flex size-8 cursor-pointer items-center justify-center rounded-chip text-ink hover:bg-surface-muted">
                            <X size={18} aria-hidden="true" className={lucide}/>
                        </Dialog.Close>
                    </div>
                    <div className="flex flex-col gap-2 p-5">
                        <PhoneNumberInput
                            phoneNumber={phoneNumber}
                            onPhoneNumberChange={(val: number | string) => setPhoneNumber(String(val))}
                            onPhoneNumberClear={() => setPhoneNumber('')}
                        />
                        <p id="external-number-desc" className="m-0 text-footnote text-ink-muted">
                            Forwarded calls are billed per minute at outbound call rates.
                        </p>
                    </div>
                    <div className="flex items-center justify-end gap-3 border-0 border-t border-solid border-line px-5 py-4">
                        <PhoneHQButton variant="secondary" className="px-5" onClick={() => onOpenChange(false)}>Cancel</PhoneHQButton>
                        <PhoneHQButton className="px-5" disabled={!valid} onClick={() => {
                            onSave(phoneNumber.replace(/\D/g, ''));
                            onOpenChange(false);
                        }}>Save</PhoneHQButton>
                    </div>
                </Dialog.Content>
            </Dialog.Portal>
        </Dialog.Root>
    );
};
